export default "__VITE_ASSET__BMqk8qlh__"